import React from 'react';

const CrmFinancesIcon = () => (
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M10.833 1.667v1.041c2.9.43 5 2.364 5 4.709h-2.5c0-1.38-1.194-2.584-3.333-2.833v3.875c3.317.686 5 2.008 5 4.208 0 2.345-2.1 4.279-5 4.709v1.041H9.167v-1.041c-2.9-.43-5-2.364-5-4.709h2.5c0 1.38 1.194 2.584 3.333 2.833v-3.875C6.683 10.939 5 9.617 5 7.417c0-2.345 2.1-4.279 5-4.709V1.667h1.666zM9.167 9.315V5.584c-1.465.367-2.5 1.299-2.5 2.208 0 .91.735 1.634 2.5 2.011v-.488zm1.666 1.37v3.731c1.465-.367 2.5-1.299 2.5-2.208 0-.909-.735-1.634-2.5-2.011v.488z"
        fill="white"
      />
    </svg>
  </div>
);

export default CrmFinancesIcon;
